var RingGraphGeneralDataToGoModelUtil = /** @class */ (function () {
    function RingGraphGeneralDataToGoModelUtil(diagram, goModel) {
        this.diagram = diagram;
        this.goModel = goModel;
    }
    RingGraphGeneralDataToGoModelUtil.prototype.saveComponentProperty = function (property, value) {
        this.diagram.model.setDataProperty(this.goModel, property, value);
    };
    RingGraphGeneralDataToGoModelUtil.prototype.saveToGoJsModel = function (data) {
        this.saveComponentProperty('rotationDirection', data.rotationDirection);
        this.saveComponentProperty('isFullRing', data.isFullRing);
        this.saveComponentProperty('startAngle', data.startAngle);
        this.saveComponentProperty('endAngle', data.endAngle);
        this.saveComponentProperty('radiusPercentage', data.radiusPercentage);
        this.saveComponentProperty('minCalibration', data.minCalibration);
        this.saveComponentProperty('maxCalibration', data.maxCalibration);
        this.saveComponentProperty('variableName', data.configureVariableId && data.configureVariableId.name ?
            data.configureVariableId.name : '');
        this.saveComponentProperty('variableVersion', data.configureVariableId && data.configureVariableId.variableVersion ?
            data.configureVariableId.variableVersion : undefined);
        this.saveComponentProperty('variableDataType', data.variableDataType ?
            data.variableDataType : undefined);
    };
    return RingGraphGeneralDataToGoModelUtil;
}());
export { RingGraphGeneralDataToGoModelUtil };
